import { Component, inject, input, output } from '@angular/core';
import { Router } from '@angular/router';
import { IEnrollmentDetailItem } from '@lb/api/mylb/interfaces';
import { EnrollmentCardV2Component } from '@lb/components/enrollment-card-v2/enrollment-card-v2.component';

@Component({
	selector: 'lrnr-enrollment-card',
	standalone: true,
	imports: [EnrollmentCardV2Component],
	template: `
		<lb-enrollment-card-v2
			[enrollment]="enrollment()"
			userView="instructor"
			[showScheduleAction]="true"
			(viewDetails)="onViewDetails($event)"
			(scheduleRequested)="onScheduleRequested($event)"
			(enrollmentAction)="enrollmentAction.emit($event)"
		>
			<ng-content select="[enrollment-links]"></ng-content>
		</lb-enrollment-card-v2>
	`
})
export class LearnerEnrollmentCardComponent {
	enrollment = input.required<IEnrollmentDetailItem>();
	enrollmentAction = output<string>();

	private _router = inject(Router);

	onViewDetails(id: number): void {
		this._router.navigate(['/enrollments', id]);
	}

	onScheduleRequested(id: number): void {
		this._router.navigate(['/enrollments', id, 'schedule']);
	}
}
